import styles from "../WorkoutAdminModal.module.css";

export default function Badge({ children, tone = "default" }) {
return (
  <span className={`${styles.wamBadge} ${styles[`wamBadge_${tone}`] || ""}`}>
    {children}
  </span>
);
}
